const MeasureAffordabilityConditions = {
	currentConditionTarget: null,
	conditionBlocks: [],
	blankRemoveButton: `<span class='Tag__remove-tag j-measure-affordability-remove-block'>&times;</span>`,
	blankTags: {
		enacting_actor: `<div class='Tag Tag--in-playarea Tag--blue-dark' style='display: block; margin-top: 8px'><span></span></div>`,
		all_actors: `<div class='Tag Tag--in-playarea Tag--green' style='display: block; margin-top: 8px'><span></span></div>`,
		actors_with_function: `<div class='Tag Tag--in-playarea Tag--lila' style='display: block; margin-top: 8px'><span></span></div>`,
		user_input: `<div class='Tag Tag--in-playarea Tag--aqua' style='display: block; margin-top: 8px'><span></span></div>`,
		property_item: `<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--gray'><span></span></div>`,
	},

	init(formFieldId, presentData, availableFunctionsPerPropTypeKey) {
		pp.log("init", formFieldId, presentData, availableFunctionsPerPropTypeKey);
		const $formField = $(`div.form-group.${formFieldId}`);

		const instance = {
			formFieldId: formFieldId,
			$formField: $formField,
			conditionBlocks: [],
			currentConditionTarget: $formField
				.find("input[name='affordability_condition_block']:checked")
				.val(),
			availableFunctionsPerPropTypeKey: availableFunctionsPerPropTypeKey,
		};

		$formField
			.find('input[name="affordability_condition_block"]')
			.on("click", (event) => {
				// @ts-expect-error
				$(event.currentTarget).closest("label").tab("show");
				instance.currentConditionTarget = $(event.currentTarget).val();
			});
		$formField.find("label[data-target]").on("shown.bs.tab", function () {
			// @ts-expect-error
			var $targetPane = $($(this).attr("data-target"));
			// @ts-expect-error
			pp.backend.formHelpers.initSelect2For($targetPane.find("select:visible"));
		});

		$formField
			.find(
				`#${formFieldId}_actors_with_function_pane select[name='condition_prop_key']`,
			)
			.on("change", instance, this.handleSelectedPropForFunctionChange);
		$formField
			.find(
				`#${formFieldId}_actors_with_function_pane select[name='condition_prop_key']`,
			)
			.trigger("change");

		$formField
			.find(".j-add-affordability-condition-button")
			.on("click", instance, this.handleAddButtonClick);

		instance.observeChange(
			"conditionBlocks",
			instance,
			this.handleConditionChanges,
		);

		// Add the unique ids for the data from Rails manually before
		presentData.forEach((arrayItem, index) => {
			const target = Object.keys(arrayItem)[0];
			// @ts-expect-error
			const conditionsHash = arrayItem[target];
			if (target == "user_input") {
				presentData[index][target].uniqId = pp.viewHelpers.generateRandomId();
			} else {
				for (const propertyKey in conditionsHash) {
					// @ts-expect-error
					presentData[index][target][propertyKey].uniqId =
						pp.viewHelpers.generateRandomId();
				}
			}
		});
		instance.conditionBlocks = presentData;
	},

	handleConditionChanges(oldval, newval, instance) {
		const module = pp.backend.formHelpers.measureAffordabilityConditions;
		// pp.log("handleConditionChanges new", newval);
		instance.$formField
			.find(".j-measure-affordability-conditions-playarea")
			.html("");
		// Wipe current input data
		module.addBlocksVisually(instance, newval);
		const filteredInput = JSON.stringify(
			newval,
			module.filterConditionBlocksForRails,
		);
		instance.$formField
			.find("textarea[name*='[affordability_conditions]']")
			.val(filteredInput);
	},

	addBlocksVisually(instance, newConditionsArray) {
		const module = pp.backend.formHelpers.measureAffordabilityConditions;
		// pp.log("addBlocksVisually, instance", instance.$formField, instance.$formField.find('.j-measure-affordability-conditions-playarea'));
		newConditionsArray.forEach((arrayItem) => {
			const target = Object.keys(arrayItem)[0];
			// @ts-expect-error
			const conditionsHash = arrayItem[target];
			const displayNameOfTarget = instance.$formField
				.find(`label[for$='_${target}']`)
				.find(".Tag")
				.text();

			let $headlineTag = $(module.blankTags[target]);
			$headlineTag.find("span").html(displayNameOfTarget);
			instance.$formField
				.find(".j-measure-affordability-conditions-playarea")
				.append($headlineTag);

			if (target !== "user_input") {
				module.composeVisualPropCondition(instance, module, conditionsHash);
			} else {
				module.composeVisualUserInputCondition(
					instance,
					module,
					conditionsHash,
				);
			}
		});
		if (!newConditionsArray.length) {
			instance.$formField
				.find(".j-measure-affordability-conditions-playarea")
				.html(I18n.t("cms.measures.no_conditions_defined"));
		}
	},

	composeVisualPropCondition(instance, module, conditionsHash) {
		let $newTag;
		for (const propertyKey in conditionsHash) {
			const conditions = conditionsHash[propertyKey];
			$newTag = $(module.blankTags.property_item);
			let tagTextContent = `${propertyKey} ${conditions.comparison_operator} ${conditions.comparison_value}`;
			if (conditions.function !== undefined) {
				tagTextContent += ` (${conditions.function})`;
			}
			$newTag.find("span").html(tagTextContent);
			$newTag.attr("data-uniq-id", conditions.uniqId);
			$newTag.append(module.blankRemoveButton);
			instance.$formField
				.find(".j-measure-affordability-conditions-playarea")
				.append($newTag);

			$newTag
				.find(".j-measure-affordability-remove-block")
				.on("click", instance, module.handleRemoveClick);
		}
	},

	composeVisualUserInputCondition(instance, module, conditionsHash) {
		const $newTag = $(module.blankTags.property_item);
		// pp.log("composeVisualUserInputCondition", conditionsHash)
		$newTag
			.find("span")
			.html(
				`${conditionsHash.comparison_operator} ${conditionsHash.comparison_value}`,
			);
		$newTag.attr("data-uniq-id", conditionsHash.uniqId);
		$newTag.append(module.blankRemoveButton);
		instance.$formField
			.find(".j-measure-affordability-conditions-playarea")
			.append($newTag);
		$newTag
			.find(".j-measure-affordability-remove-block")
			.on("click", instance, module.handleRemoveClick);
	},

	handleAddButtonClick(event) {
		// pp.log("handleAddButtonClick", event.data);
		const instance = event.data;
		const $formField = instance.$formField;

		const $conditionTypePane = $formField.find(
			`#${instance.formFieldId}_${instance.currentConditionTarget}_pane`,
		);
		const propTypeKey = $conditionTypePane
			.find("[name='condition_prop_key']")
			.val();
		const $comparisonOperatorInput = $conditionTypePane.find(
			"[name='condition_comparison_operator']",
		);
		let $comparisonValueInput = $conditionTypePane.find(
			"[name='condition_comparison_value']",
		);
		const $targetFunctionInput = $conditionTypePane.find(
			"[name='condition_function']",
		);

		// For the "connection name" select in the condition "enacting_actor"
		if ($comparisonValueInput.length > 1) {
			$comparisonValueInput = $conditionTypePane.find(
				"[name='condition_comparison_value']:visible",
			);
		}

		let dupedConditionBlocks = Object.assign([], instance.conditionBlocks);
		let comparisonValue = parseFloat($comparisonValueInput.val());
		if (isNaN(comparisonValue)) {
			// For the "connection name" select in the condition "enacting_actor", otherwise always expect a number
			if ($comparisonValueInput.is("select")) {
				comparisonValue = $comparisonValueInput.val();
			} else {
				pp.notifications.display("error", `Please enter a valid number!`);
				return;
			}
		}
		let conditionToAdd = {
			comparison_operator: $comparisonOperatorInput.val(),
			comparison_value: comparisonValue,
			uniqId: pp.viewHelpers.generateRandomId(),
		};
		if ($targetFunctionInput.length) {
			conditionToAdd.function = $targetFunctionInput.val();
		}

		let conditionBlockEntryWithType;
		const indexOfConditionBlockEntryWithType = dupedConditionBlocks.findIndex(
			(arrayItem) => {
				return instance.currentConditionTarget == Object.keys(arrayItem)[0]; // There should always ever be a hash with one key in each array item
			},
		);
		if (indexOfConditionBlockEntryWithType == -1) {
			conditionBlockEntryWithType = {};
			if (instance.currentConditionTarget != "user_input") {
				conditionBlockEntryWithType[instance.currentConditionTarget] = {};
			}
		} else {
			// Found
			conditionBlockEntryWithType = dupedConditionBlocks.splice(
				indexOfConditionBlockEntryWithType,
				1,
			)[0]; // `splice` returns an array
		}

		if (instance.currentConditionTarget != "user_input") {
			if (
				conditionBlockEntryWithType[instance.currentConditionTarget][
					propTypeKey
				] !== undefined
			) {
				pp.notifications.display(
					"error",
					`Entry for type '${instance.currentConditionTarget}' and Property '${propTypeKey}' does already exist!`,
				);
				return;
			}
			conditionBlockEntryWithType[instance.currentConditionTarget][
				propTypeKey
			] = conditionToAdd;
		} else {
			if (
				conditionBlockEntryWithType[instance.currentConditionTarget] !==
				undefined
			) {
				pp.notifications.display(
					"error",
					`Entry for type '${instance.currentConditionTarget}' and does already exist!`,
				);
				return;
			}
			conditionBlockEntryWithType[instance.currentConditionTarget] =
				conditionToAdd;
		}
		dupedConditionBlocks.push(conditionBlockEntryWithType);
		instance.conditionBlocks = dupedConditionBlocks;

		$comparisonValueInput.val("");
	},

	handleRemoveClick(event) {
		// pp.log("handleRemoveClick", event.data);
		const instance = event.data;
		const uniqId = parseInt(
			// @ts-expect-error
			$(event.currentTarget).closest(".Tag").attr("data-uniq-id"),
		);

		let dupedConditionBlocks = Object.assign([], instance.conditionBlocks);
		// pp.log("uu", uniqId, dupedConditionBlocks);

		dupedConditionBlocks.forEach((arrayItem, index) => {
			const target = Object.keys(arrayItem)[0];
			// @ts-expect-error
			const conditionsHash = arrayItem[target];
			if (target == "user_input") {
				delete dupedConditionBlocks[index][target];
				dupedConditionBlocks.splice(index, 1);
			} else {
				for (const propertyKey in conditionsHash) {
					if (conditionsHash[propertyKey].uniqId != uniqId) {
						continue;
					}

					// @ts-expect-error
					delete dupedConditionBlocks[index][target][propertyKey];
					// @ts-expect-error
					if (Object.keys(dupedConditionBlocks[index][target]).length) {
						continue;
					}
					// else
					// @ts-expect-error
					delete dupedConditionBlocks[index][target];
					if (!dupedConditionBlocks[index].length) {
						dupedConditionBlocks.splice(index, 1);
					}
				}
			}
		});
		// pp.log("remaining,", dupedConditionBlocks);
		instance.conditionBlocks = dupedConditionBlocks;
	},

	handleSelectedPropForFunctionChange(event) {
		const instance = event.data;
		const $functionSelect = instance.$formField.find(
			`#${instance.formFieldId}_actors_with_function_pane select[name='condition_function']`,
		);
		$functionSelect.find("option").prop("disabled", true);
		var selectedType = event.currentTarget.value;
		if (instance.availableFunctionsPerPropTypeKey[selectedType] === undefined) {
			return;
		}
		instance.availableFunctionsPerPropTypeKey[selectedType].forEach(
			(available_function) => {
				$functionSelect
					.find(`option[value='${available_function}']`)
					.prop("disabled", false);
			},
		);
		$functionSelect
			.find(
				`option[value='${instance.availableFunctionsPerPropTypeKey[selectedType][0]}']`,
			)
			.prop("selected", true);
		$functionSelect.trigger("change");
	},

	filterConditionBlocksForRails(key, value) {
		if (["uniqId", "tagTextContent"].includes(key)) {
			return undefined;
		}
		return value;
	},
};

export default MeasureAffordabilityConditions;
